import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosClient } from "redux/AxiosClient";

export const addMasterSpeedLearnAsync = createAsyncThunk(
  "admin/addMasterSpeedLearn",
  async (payload, toolkit) => {
    return await AxiosClient("POST", `/addMasterSpeedLearn`, payload, toolkit);
  }
);

export const getAllMasterSpeedLearnAsync = createAsyncThunk(
  "admin/getAllMasterSpeedLearn",
  async (payload, toolkit) => {
    return await AxiosClient(
      "GET",
      `/getAllMasterSpeedLearn?page=${payload.page || ""}&limit=${
        payload.limit || ""
      }`,
      [],
      toolkit
    );
  }
);

export const getMasterSpeedLearnByIdAsync = createAsyncThunk(
  "admin/getMasterSpeedLearnById",
  async (payload, toolkit) => {
    return await AxiosClient(
      "GET",
      `/getMasterSpeedLearn/${payload}`,
      [],
      toolkit
    );
  }
);

export const updateMasterSpeedLearnAsync = createAsyncThunk(
  "admin/updateMasterSpeedLearn",
  async (payload, toolkit) => {
    return await AxiosClient(
      "PUT",
      `/updateMasterSpeedLearn`,
      payload,
      toolkit
    );
  }
);

export const deleteMasterSpeedLearnAsync = createAsyncThunk(
  "admin/deleteMasterSpeedLearn",
  async (payload, toolkit) => {
    return await AxiosClient(
      "DELETE",
      `/deleteMasterSpeedLearn/${payload}`,
      [],
      toolkit
    );
  }
);
